import { render, staticRenderFns } from "./publicProject.vue?vue&type=template&id=7d998db7&scoped=true&"
import script from "./publicProject.vue?vue&type=script&lang=js&"
export * from "./publicProject.vue?vue&type=script&lang=js&"
import style0 from "./publicProject.vue?vue&type=style&index=0&id=7d998db7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d998db7",
  null
  
)

export default component.exports